var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnifierCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24860",
    "data-name": "Group 24860",
    transform: "translate(-1267.256 -1155.257)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24456",
    "data-name": "Group 24456",
    transform: "translate(1267 1155)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1564",
    "data-name": "Ellipse 1564",
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    transform: "translate(0.256 0.257)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass_1_",
    "data-name": "magnifying-glass (1)",
    transform: "translate(1274.256 1162.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7345",
    "data-name": "Path 7345",
    d: "M6.011,1.03A3.522,3.522,0,1,0,5.53,6.41a.741.741,0,0,0,.2.373l2,2A.744.744,0,0,0,8.783,7.731l-2-2a.744.744,0,0,0-.373-.2A3.525,3.525,0,0,0,6.011,1.03ZM5.38,5.38a2.629,2.629,0,1,1,0-3.718A2.632,2.632,0,0,1,5.38,5.38Z",
    transform: "translate(-0.001 0)",
    fill: "#172b37"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifierCircle);
export default __webpack_public_path__ + "static/media/magnifier_circle.285a44b23845926e94bd4d4cc2258d34.svg";
export { ForwardRef as ReactComponent };